<template>
    <VTextField
        ref="input"
        :label="label"
        v-currency="options"
        :value="formattedValue"
        @change="onChange"
        @input="onInput"
        :disabled="readonly"
        :dense = "dense"
        :outlined = "outlined"

        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"

        :hide-details="hideDetails"
        :readonly="readonly"
        :rules="rules"
        :error-messages="errorMessages"
    />
</template>

<script>
export default {
    name: "FCurrencyField",
    props: {
        value: {
            type: Number,
            default: null
        },
        label: {
        },
        rules: {
            required: false,
            type: Array,
            default: function () {
                return [];
            }
        },
        readonly: {
            required: false,
            default: function () {
                return false;
            }
        },
        hideDetails: {
            required: false,
            default: function () {
                return false;
            }
        },
        options: {
            type: Object,
            default: () => {}
        },
        errorMessages: {
            required: false,
            type: Array,
            default: function () {
                return [];
            }
        },
        dense: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        outlined: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },
    },
    data() {
        return {
            formattedValue: null
        };
    },
    watch: {
        value(value) {
            this.setValue(value);
        }
    },
    mounted() {
        this.setValue(this.value);
    },
    methods: {
        setValue(value) {
            this.$ci.setValue(this.$refs.input, value);
        },
        onInput(value) {
            this.$emit("input", this.$ci.getValue(this.$refs.input));
            this.formattedValue = value;
        },
        onChange(value) {
            this.$emit("change", this.$ci.getValue(this.$refs.input));
            this.formattedValue = value;
        }
    }
};
</script>
